const MENU_IS_OPEN = 'menu-is-open';
const ACTIVE_CLASS = 'is-active';
const CLICKED_CLASS = 'clicked';

import store from '../util/store';
import RafManager from '../util/RafManager';
import anime from 'animejs';
import {scrollTo} from '../functions';

export default class NavbarAnimation {
  constructor() {
    this.$menu = document.querySelector('.js-primary-menu');
    this.$menuTrigger = document.querySelector('.js-primary-menu-trigger');
    this.$mainTriggers = this.$menu.querySelectorAll('.js-primary-menu-closer');
    this.$logo = document.querySelector('.js-logo');
    this.fadeIn = null;
    this.oldScroll = 0;

    this.bindEvents();

    RafManager.addQueue(this.onScroll.bind(this));
  }

  bindEvents() {
    this.$menuTrigger.addEventListener('click', () => {
      const hasClass = document.body.classList.toggle(MENU_IS_OPEN);

      if(hasClass) {
        store.lockBody();
        // store.disableScrollHard();
      } else {
        store.unlockBody();
        store.enableScrollHard();
        this.resetNavbar();
      }
    });

    this.$mainTriggers.forEach( $el => {
      $el.addEventListener('click', () => {
        document.body.classList.remove(MENU_IS_OPEN);
        store.unlockBody();
        store.enableScrollHard();
      });
    });
  }

  onScroll() {
    if (document.body.classList.contains(MENU_IS_OPEN)) {
      setTimeout( () => {
        this.$logo.classList.remove('is-translated');
      }, 650);
    } else {
      if (store.scrollTop > 50) {
        this.$menu.classList.remove('no-background');
        if (store.scrollTop - this.oldScroll < 0 && store.windowWidth > 1000) {
          this.$logo.classList.remove('is-translated');
          this.$menu.classList.remove('is-translated');
        } else if (store.scrollTop != this.oldScroll) {
          this.$logo.classList.add('is-translated');
          this.$menu.classList.add('is-translated');
        }
      } else {
        this.$menu.classList.add('no-background');
        this.$logo.classList.remove('is-translated');
        this.$menu.classList.remove('is-translated');
      }
    }
    this.oldScroll = store.scrollTop;
  }

  createFadeIn() {
    this.fadeIn = anime({
      targets: [this.$logo, this.$menu, this.$menuTrigger],
      opacity: {
        value: [0, 1],
        duration: 500,
        easing: 'easeInOutQuart',
      },
      autoplay: false,
    });
  }

  resetNavbar() {
    const $dropdowns = Array.from(this.$menu.querySelectorAll('.js-dropdown'));
    const $triggers = Array.from(this.$menu.querySelectorAll('.js-dropdown-trigger'));

    $triggers.map( $trigger => $trigger.classList.remove(CLICKED_CLASS));
    $dropdowns.map( $dropdown => {
      $dropdown.classList.remove(ACTIVE_CLASS)
      $dropdown.style.height = '';
    });

    scrollTo({to: 0, $container: document.querySelector('.js-primary-menu')}); // specific to navbar menu
  }
}



// WEBPACK FOOTER //
// ./scripts/animation/NavbarAnimation.js